import React, { FC } from 'react';
import { CustomModalProps } from './CustomModalProps';
import Modal, { ModalHeader, Sheets } from '@ingka/modal';
import ConfirmationModal from '../../common/ConfirmationModal';
import Button from '@ingka/button';
import useTranslation from '../../hooks/useTranslation';

const CustomModal: FC<CustomModalProps> = ({
  isVisible,
  onClose,
  title,
  children,
  onBackBtnClick,
  useConfirmation,
  formModified,
  testid,
  size,
  statusConfirmationModal,
  closeStatusConfirmationModal,
  proceedStatusUpdate,
}) => {
  const t = useTranslation();
  const [confirmationModalVisible, setConfirmationModalVisible] =
    React.useState(false);
  const showConfirmationModal = () => {
    setConfirmationModalVisible(true);
  };
  const closeConfirmationModal = () => {
    setConfirmationModalVisible(false);
  };

  return (
    <>
      <Modal
        visible={isVisible}
        data-testid={testid}
        handleCloseBtn={() => {
          if (useConfirmation && formModified) {
            showConfirmationModal();
          } else {
            onClose();
          }
        }}
      >
        <Sheets
          style={{ height: '100%' }}
          alignment={'right'}
          size={size || 'medium'}
          header={
            <ModalHeader
              title={title}
              floating={false}
              backBtnClick={onBackBtnClick}
            />
          }
          footer={<></>}
        >
          {children}
        </Sheets>
      </Modal>
      <ConfirmationModal
        visible={confirmationModalVisible && formModified}
        closeHandler={closeConfirmationModal}
        title={'You have work in progress'}
        text={'Are you sure you want to close? Any data filled in will be lost'}
      >
        <>
          <Button
            style={{ width: '12.5rem', marginRight: '1.5rem' }}
            data-testid={'confirm-close-button'}
            type={'danger'}
            text={t('common.yesSure')}
            onClick={() => {
              closeConfirmationModal();
              onClose();
            }}
          />
        </>
      </ConfirmationModal>
      <ConfirmationModal
        visible={statusConfirmationModal}
        closeHandler={closeStatusConfirmationModal}
        title={'You have work in progress'}
        text={
          'You have to finish updating the project before status change. Do you want to continue?'
        }
      >
        <>
          <Button
            style={{ width: '12.5rem', marginRight: '1.5rem' }}
            data-testid={'confirm-close-button'}
            type={'secondary'}
            text={'Cancel and continue editing'}
            onClick={() => {
              closeStatusConfirmationModal();
            }}
          />
          <Button
            style={{ width: '12.5rem', marginRight: '1.5rem' }}
            data-testid={'confirm-close-button'}
            type={'primary'}
            text={'Update project and proceed with status change'}
            onClick={() => {
              proceedStatusUpdate();
            }}
          />
        </>
      </ConfirmationModal>
    </>
  );
};

export default CustomModal;
